module.exports = __webpack_public_path__ + "img/victoria_maraia_8.888c19bc.jpg";